import React, { createContext, useContext, useState } from "react"

type NavigationLayoutOffsetHeight = number
type NavigationLayoutContextType = {
  navigationLayoutOffsetHeight: number
  setNavigationLayoutOffsetHeight: (value: number) => void
}

const defaultValue = {
  navigationLayoutOffsetHeight: 0,
  setNavigationLayoutOffsetHeight: () => null
}

export const NavigationLayoutContext = createContext<NavigationLayoutContextType>(defaultValue)

export const NavigationLayoutProvider: React.FC = ({ children }) => {
  const [navigationLayoutOffsetHeight, setNavigationLayoutOffsetHeight] = useState<NavigationLayoutOffsetHeight>(
    defaultValue.navigationLayoutOffsetHeight
  )

  return (
    <NavigationLayoutContext.Provider
      value={{
        navigationLayoutOffsetHeight,
        setNavigationLayoutOffsetHeight
      }}
    >
      {children}
    </NavigationLayoutContext.Provider>
  )
}

export const useNavigationLayout = () => useContext(NavigationLayoutContext)
